import React from 'react';

const Intro = () => {
  return (
    <section id="intro" className="section introduction">
      <h1 className="title">Enrique Cabello Delgado</h1>
      <p className="sub-title">IT / IoT Project Manager & Developer</p>
      <p className="description">
        Specialized in IT infrastructure management and IoT project development. 
        Passionate about creating innovative solutions that bridge technology and business needs.
      </p>
      <div className="cta-buttons">
        <a href="#projects" className="button secondary">View Projects</a>
      </div>
      
      
    </section>
  );
};

export default Intro; 